/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Placeholder, PlaceholderText } from 'sarsaparilla';
import './PlanYourVisitPlaceholder.scss';

export default function PlanYourVisitPlaceholder() {
    return (
        <div
            className="campground-page-v3-plan-your-visit campground-page-v3-section"
            aria-hidden="true"
        >
            <Placeholder
                className="campground-page-v3-plan-your-visit-placeholder-heading"
                height="32px"
                width="220px"
            />
            <div className="campground-page-v3-plan-your-visit-content campground-page-v3-plan-your-visit-placeholder-content">
                <Placeholder height="24px" width="60%" />
                <PlaceholderText fontSize={23} lineHeight={22} lines={2} />

                <div className="campground-page-v3-plan-your-visit-placeholder-divider" />

                <Placeholder height="24px" width="55%" />
                <PlaceholderText fontSize={23} lineHeight={22} lines={1} width="96%" />
            </div>
        </div>
    );
}
